import React from 'react';
import ReactDOM from 'react-dom/client';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import 'typeface-roboto';

const rootElement = document.getElementById('root');

// Recorded before hydration — once React takes over, #root always has children.
// App.js reads this to skip the intro loader on prerendered pages, which would
// otherwise cover content the browser had already painted.
window.__PRERENDERED__ = rootElement.hasChildNodes();

// use hydrate for prerendered pages, createRoot for a cold client render
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, <React.StrictMode><App /></React.StrictMode>);
} else {
  createRoot(rootElement).render(<React.StrictMode><App /></React.StrictMode>);
}
